import { Link } from "react-router-dom";
import { BookOpen, Heart } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-border bg-slate-50 mt-16">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid gap-8 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
            <BookOpen className="h-5 w-5 text-white" />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight text-slate-900">
            Notes<span className="text-primary">Bazaar</span>
          </span>
        </div>
        <p className="text-sm text-muted-foreground mt-4 max-w-sm leading-relaxed">
          Bharat's marketplace for student notes. From Kota to Delhi, buy and sell topper-made
          notes for JEE, NEET, UPSC, CBSE boards and college semesters — all in ₹.
        </p>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-overline text-slate-900 mb-3">Explore</p>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/" className="hover:text-primary">Browse notes</Link></li>
          <li><Link to="/sell" className="hover:text-primary">Sell your notes</Link></li>
          <li><Link to="/purchases" className="hover:text-primary">My library</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-overline text-slate-900 mb-3">Popular</p>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li>JEE & NEET</li>
          <li>UPSC & State PSC</li>
          <li>CBSE Boards</li>
          <li>GATE & CAT</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
        <span>© {new Date().getFullYear()} NotesBazaar. All rights reserved.</span>
        <span className="flex items-center gap-1.5">
          Made with <Heart className="h-4 w-4 text-orange-500 fill-orange-500" /> in India
          <span className="ml-1 flex gap-0.5">
            <span className="h-2 w-2 rounded-full bg-orange-500" />
            <span className="h-2 w-2 rounded-full bg-white border border-slate-300" />
            <span className="h-2 w-2 rounded-full bg-green-600" />
          </span>
        </span>
      </div>
    </div>
  </footer>
);
